export default{
   "mediaaccesserrormessage": "Es kann leider nicht auf das Mikrofon und/oder die Kamera zugegriffen werden! <br>Sie sind daher nur als Zuhörer dabei!",
   "errortosavechat": "In Ihrem Browser kann der Chat leider nicht gespeichert werden!",
   "chatfilesizetogreat": "Die Datei ist zu groß für den Versand, die Datei darf nur 256kb groß sein!",
   "firebaseautherror": "Autentifizierungsfehler bei Firebase!<br>Die Seite muss neu geladen werden!",
   "You": "Du",
   "yourmessage": "Deine Nachricht...",
   "inviteotherwithlink": "Lade andere über den Link ein",
   "name": "Name",
   "microphone": "Mikrofon",
   "video": "Kamera",
   "speaker": "Lautsprecher",
   "chat": "Chat",
   "participant": "Teilnehmer",
   "settings": "Einstellungen",
   "ok": "ok",
   "buildownvideochat": "Baue deinen eigenen Video Chat",
   "reportabug": "Melde einen Fehler",
   "createaroom": "Erstelle einen Raum",
   "create": "Erstellen",
   "roomname": "Raum-Name",
   "connect": "Verbinde...",
   "imprint": "Impressum",
   "privacy": "Datenschutz",
   "cannotstartcamera": "Es kann nicht auf eine Kamera zugegriffen werden!",
   "cannotstartmicrophone": "Es kann nicht auf ein Mikrofon zugegriffen werden!",
   "search": "Suchen...",
   "nointernet": "Keine Internet Verbindung...",
   "soundeffects": "Sound Effekte",
   "yourname": "Dein Name",
   "starting": "Starten",
   "fullscreenon": "Vollbild ein",
   "fullscreenoff": "Vollbild aus",
   "mute": "Stumm schalten",
   "sound off": "Ton aus",
   "sound on": "Ton ein"
}